import type { SavedView } from '~/types/saved-view'

export function useSavedViews() {
  const supabase = useSupabaseClient()
  const auth = useAuthStore()

  async function list(page: 'customers' | 'calls'): Promise<SavedView[]> {
    const { data, error } = await supabase
      .from('saved_views').select('*')
      .eq('page', page).order('position').order('name')
      .returns<SavedView[]>()
    if (error) throw error
    return data ?? []
  }

  async function create(input: { name: string; page: 'customers' | 'calls'; filters: any }): Promise<SavedView> {
    const { data, error } = await supabase
      .from('saved_views')
      .insert({ ...input, created_by: auth.user!.id } as never)
      .select('*').single<SavedView>()
    if (error) throw error
    return data
  }

  async function update(id: string, patch: Partial<Pick<SavedView, 'name' | 'filters' | 'position'>>): Promise<void> {
    const { error } = await supabase.from('saved_views')
      .update({ ...patch, updated_at: new Date().toISOString() } as never).eq('id', id)
    if (error) throw error
  }

  async function remove(id: string): Promise<void> {
    const { error } = await supabase.from('saved_views').delete().eq('id', id)
    if (error) throw error
  }

  return { list, create, update, remove }
}
